export default "/images/login-vector2.svg?8431f70ed49a489f143039f237dccb93";